import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {MatDialog} from "@angular/material/dialog";
import {TranslateModule} from "@ngx-translate/core";
import {AgendaelementModell, SaksdokumentModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {MatTooltip} from "@angular/material/tooltip";
import {DokumentBakgrunnDirektiv, DokumentFilnavnDirektiv, DokumentHandlingDirektiv, DokumentKomponent} from "web-ng2/delt/komponenter/dokument/dokument";
import {GoogleDriveFilvelgerDialogKomponent} from "web-ng2/delt/komponenter/filvelger-skytjenester/modale/googledrive-filvelger-dialog/googledrive-filvelger-dialog";
import {MatIcon} from "@angular/material/icon";

const debug = initDebugger('GoogleDriveFilvelgerKomponent');

@Component({
    selector: 'googledrive-filvelger',
    templateUrl: 'googledrive-filvelger.html',
    styleUrl: 'googledrive-filvelger.scss',
    imports: [
        TranslateModule,
        MatTooltip,
        DokumentKomponent,
        DokumentFilnavnDirektiv,
        DokumentHandlingDirektiv,
        DokumentBakgrunnDirektiv,
        MatIcon
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GoogleDriveFilvelgerKomponent {
    static ajsSelector = 'googledriveFilvelger';

    @Output() vedAktivert = new EventEmitter<void>();
    @Input({required: true}) sak!: AgendaelementModell;

    constructor(private dialog: MatDialog) {
    }

    async visFilvelger() {
        GoogleDriveFilvelgerDialogKomponent.vis(this.dialog, this.sak.id, this.sak.moete.id, (filnavn: string) => this.eksisterendeDokument(filnavn))
        this.vedAktivert.emit();
    }

    // private hjelpemetoder

    /** Returnerer eventuelt eksisterende saksdokument med samme filnavn.
     * Gjør case-sensitiv sammenlikning - slik er det også ved opplasting av dokumenter fra bruker disk.. */
    private eksisterendeDokument(filnavn: string): SaksdokumentModell | null {
        return this.sak.dokumenter.find(eksisterende => eksisterende.filnavn == filnavn) ?? null;
    }
}


